import {
	createAsyncThunk,
	createSlice,
	createSelector,
} from "@reduxjs/toolkit";
import {
	getCPEFormById,
	getRequestFormById,
	getRequestLinesByParentFormId,
} from "api";

const initialState = {
	error: null,
	status: "starting",
	data: {
		formTypeId: null,
		requestLines: [],
		leaveLines: [],
	},
	childrenRequestLines: [],
};

export const fetchParentFormById = createAsyncThunk(
	"parentForm/fetchParentFormById",
	//need the thunkApi's getState to retrieve auth token
	async (formId, { rejectWithValue, dispatch }) => {
		try {
			let data = await getRequestFormById({ formId });
			if (!data) {
				data = await getCPEFormById({ formId });
			}
			dispatch(parentFormReceived(data));
			return data;
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

export const fetchChildrenRequestLinesByParentFormId = createAsyncThunk(
	"parentForm/fetchChildrenRequestLinesByParentFormId",
	//need the thunkApi's getState to retrieve auth token
	async (id, { rejectWithValue, dispatch }) => {
		try {
			const data = await getRequestLinesByParentFormId({
				parentFormId: id,
			});
			dispatch(childrenRequestLinesReceived(data));
			return data;
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

const parentFormSlice = createSlice({
	name: "parentForm",
	initialState,
	reducers: {
		parentFormReceived(state, action) {
			state.data = { ...initialState.data, ...action.payload }; //retain the initial state, in case blank parent form is returned
		},
		childrenRequestLinesReceived(state, action) {
			state.childrenRequestLines = action.payload;
		},
	},
	extraReducers: {
		RESET_CME: (state, action) => {
			return initialState;
		},
		[fetchParentFormById.pending](state, action) {
			state.status = "loading";
		},
		[fetchParentFormById.fulfilled](state, action) {
			state.status = "idle";
		},
		[fetchParentFormById.rejected](state, action) {
			state.status = "error";
		},
	},
});

export const { parentFormReceived, childrenRequestLinesReceived } =
	parentFormSlice.actions;

export const selectParentFormStatus = (state) => state.cme.parentForm.status;

export const selectParentFormId = (state) => state.cme.parentForm.data.formId;

export const selectParentFormData = (state) => state.cme.parentForm.data;

export const selectParentFormTypeId = (state) =>
	state.cme.parentForm.data.formTypeId;

export const selectParentRequestLines = (state) =>
	state.cme.parentForm.data.requestLines;

export const selectAllChildrenRequestLines = (state) =>
	state.cme.parentForm.childrenRequestLines || [];

export const selectParentRequestAmount = createSelector(
	[selectParentRequestLines],
	(r) => {
		return r.reduce((acc, val) => {
			return val.emolumentAmount !== 0
				? acc + val.grossAmount + val.emolumentAmount
				: acc + (val.netAmount > 0 ? val.netAmount : val.amount); //cpe request forms store their value in the amount field
		}, 0);
	}
);

export const selectParentOtherClaimAmount = createSelector(
	[selectAllChildrenRequestLines, (_, formId) => formId],
	(r, formId) => {
		return r
			.filter((l) => l.formId !== formId)
			.reduce((acc, val) => {
				return val.emolumentAmount !== 0
					? acc + val.grossAmount + val.emolumentAmount
					: acc + val.netAmount;
			}, 0);
	}
);

export default parentFormSlice.reducer;
